exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-6d674bd2] {\n  margin-top: 20px;\n}\n.form-group[data-v-6d674bd2] {\n  margin-bottom: 15px;\n}\n.btn[data-v-6d674bd2] {\n  background-color: #8B0000;\n  color: white;\n}\n", ""]);

// exports
